<template>
  <div>
    <div class="d-flex">
      <h5 v-if="isMobile">
        <b>Metering Information</b>
      </h5>
      <h3 v-else>
        <b>Metering Information</b>
      </h3>
      <div class="ml-5">
        <div v-if="editing">
          <b-link class="buttontext-2" @click="resetForm">Cancel</b-link>
          <b-link class="buttontext ml-4" @click="onSubmit">Save</b-link>
        </div>
        <b-link v-else-if="canUpdate" @click="onClickUpdate">
          <b-img
            width="16"
            class="rounded-0 mr-2 mb-1"
            :src="require('@/assets/icons/edit.svg')"
          ></b-img>
          <span class="buttontext">Update</span>
        </b-link>
      </div>
    </div>

    <b-row class="mt-2" :class="rowClass">
      <b-col>
        <b-form-group id="input-group-nmi" class="col-12">
          <i
            class="clearable"
            v-show="form.account_number && editing"
            @click="form.account_number = ''"
            >&times;</i
          >

          <b-form-input
            id="input-nmi"
            v-model="form.account_number"
            class="input-effect"
            :class="form.account_number ? 'has-content' : ''"
            required
            aria-describedby="input-nmi-feedback"
            :disabled="!editing"
          ></b-form-input>
          <label>NMI or account number</label>

          <div class="input-error" v-if="form.$getError('account_number')">
            {{ form.$getError('account_number')[0] }}
          </div>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group id="input-group-meter-1" class="col-12">
          <i
            class="clearable"
            v-show="form.meter_number_1 && editing"
            @click="form.meter_number_1 = ''"
            >&times;</i
          >

          <b-form-input
            id="input-meter-1"
            v-model="form.meter_number_1"
            class="input-effect"
            :class="form.meter_number_1 ? 'has-content' : ''"
            required
            aria-describedby="input-meter-1-feedback"
            :disabled="!editing"
          ></b-form-input>
          <label>Meter number 1</label>

          <div class="input-error" v-if="form.$getError('meter_number_1')">
            {{ form.$getError('meter_number_1')[0] }}
          </div>
        </b-form-group>
      </b-col>

      <b-col></b-col>
    </b-row>

    <b-row :class="rowClass">
      <b-col>
        <b-form-group id="input-group-meter-2" class="col-12">
          <i
            class="clearable"
            v-show="form.meter_number_2 && editing"
            @click="form.meter_number_2 = ''"
            >&times;</i
          >

          <b-form-input
            id="input-meter-2"
            v-model="form.meter_number_2"
            class="input-effect"
            :class="form.meter_number_2 ? 'has-content' : ''"
            required
            aria-describedby="input-meter-2-feedback"
            :disabled="!editing"
          ></b-form-input>
          <label>Meter number 2</label>

          <div class="input-error" v-if="form.$getError('meter_number_2')">
            {{ form.$getError('meter_number_2')[0] }}
          </div>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group id="input-group-meter-3" class="col-12">
          <i
            class="clearable"
            v-show="form.meter_number_3 && editing"
            @click="form.meter_number_3 = ''"
            >&times;</i
          >

          <b-form-input
            id="input-meter-3"
            v-model="form.meter_number_3"
            class="input-effect"
            :class="form.meter_number_3 ? 'has-content' : ''"
            required
            aria-describedby="input-meter-3-feedback"
            :disabled="!editing"
          ></b-form-input>
          <label>Meter number 3</label>

          <div class="input-error" v-if="form.$getError('meter_number_3')">
            {{ form.$getError('meter_number_3')[0] }}
          </div>
        </b-form-group>
      </b-col>

      <b-col></b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Form from '@/utils/form'

export default {
  props: {
    canUpdate: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    ...mapState({
      board: state => state.board.boardDetails
    }),

    rowClass() {
      return this.isMobile ? 'd-block' : ''
    }
  },

  data() {
    return {
      loading: false,
      editing: false,
      form: new Form({
        board_id: null,
        account_number: null,
        meter_number_1: null,
        meter_number_2: null,
        meter_number_3: null
      })
    }
  },

  methods: {
    ...mapActions({
      updateBoard: 'board/updateBoard'
    }),

    onClickUpdate() {
      this.editing = true
    },

    resetForm() {
      this.editing = false
      for (let key in this.form) {
        this.form[key] = this.board[key]
      }
      this.form.$clearErrors()
    },

    async onSubmit() {
      this.loading = true
      await this.updateBoard({
        board_id: this.form.board_id,
        account_number: this.form.account_number,
        meter_number_1: this.form.meter_number_1,
        meter_number_2: this.form.meter_number_2,
        meter_number_3: this.form.meter_number_3
      })
        .then(() => {
          this.editing = false
        })
        .catch(error => {
          this.form.$handleError(error)
        })
      this.loading = false
    }
  },

  created() {
    this.$root.$on('boardLoaded', () => {
      this.resetForm()
    })
  }
}
</script>

<style lang="scss" scoped>
.form-control:disabled,
.form-control[readonly] {
  background-color: #f8f9fa;
}
.buttontext {
  font-size: 14px;
  font-weight: bold;
}
.buttontext-2 {
  color: grey;
  font-size: 14px;
}
</style>
